





























































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {DeletePatPreTemp, GetPatPreTemps, GetPatTSchemes, LoadPatPreTemp, OperatePatTScheme} from "@/api/patient";
import AddOrEdit from './addOrEdit.vue'
import AddOrEditTemp from './addOrEditTemp.vue'

@Component({
	components: {AddOrEdit, AddOrEditTemp}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	addOrEditShow = false
	addOrEditData: any = {}
	addOrEditTempShow = false
	addOrEditTempData: any = {}
	pres: any = []
	temps: any = []
	showStopValue: boolean = false
	loading = false
	columns = [{
		title: '制定时间',
		render: (h: any, params: any) => {
			return h('span', this.formatDate(params.row.creationTime))
		}
	}, {
		title: "透析模式",
		key: 'dialysisWay'
	}, {
		title: "制定医生",
		key: 'creatorUser'
	}, {
		title: '操作',
		width: 200,
		render: (h: any, params: any) => {
			return h('div',[
				h('Button', {
					props: {
						type: 'primary'
					},
					style:{
						marginRight: '15px'
					},
					on:{
						click:()=>{
							this.editPre(params.row)
						}
					}
				}, "编辑"),
				h('Button', {
					props: {
						type: 'primary'
					},
					on:{
						click:()=>{
							this.deletePre(params.row)
						}
					}
				}, "删除")
			])
		}
	}]

	showStop(show: boolean) {
		if (show) {
			this.getPres(false)
		} else {
			this.getPres(true)
		}
	}

	created() {
		this.init()
	}

	addOne(name: any) {
		if (name === '血透治疗方案') {
			this.addOrEditData = {
				mode: 'add',
				name: name,
				patient: this.patient
			}
			this.addOrEditShow = true
		} else {
			this.addOrEditTempData = {
				mode: 'add',
				name: name,
				patient: this.patient
			}
			this.addOrEditTempShow = true
		}

	}

	async deleteOrStopPre(type: number, item: any) {
		let message = (type === 0 ? '停用' : '删除') + '该记录, 是否继续?'
		this.$confirm(message, '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await OperatePatTScheme({
				type: type,
				id: item.id
			})
			if (res.status === 1) {
				this.init()
			}
		}).catch(() => {

		});

	}

	saveSuccess() {
		this.addOrEditShow = false
		this.addOrEditTempShow = false
		this.init()
	}

	private async init() {
		this.showStopValue = false
		this.getPres(true)
		this.getTemps()
	}

	/**
	 *        获取血透治疗方案
	 *        status:为true时获取的是使用中的治疗方案，
	 *                为false时为页面上点击显示停用方案，这时将结果加到页面上显示的结果中
	 *
	 * */
	async getPres(status: boolean) {
		let res = await GetPatTSchemes({PatientId: this.patient.id, Status: status})
		if (status) {
			this.pres = res.objects
		} else {
			let tempList = Object.assign([], res.objects)
			let temp = tempList.map(function (item: any) {
				item.stoped = true;
				return item
			})
			this.pres.push(...temp)
		}
	}

	async getTemps() {
		let res1 = await GetPatPreTemps({PatientId: this.patient.id})
		this.temps = res1.objects
	}
	async editPre(row:any){
		// dialysisWay
		let res = await LoadPatPreTemp({DialysisWay:row.dialysisWay, PatientId: this.patient.id})
		this.addOrEditTempData = {
			mode: 'edit',
			name: name,
			item: res.objects,
			patient: this.patient
		}
		this.addOrEditTempShow = true

	}
	private async deletePre(row: any) {
		let res = await DeletePatPreTemp({Id:row.id})
		if (res.status === 1) {
			this.init()
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisPre/index.vue